module.exports = {"langs":[{"slug":"en","title":"English"},{"slug":"ru","title":"Russian"}],"materialsText":"Articles","menuText":"Menu"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/top-nav.en.json
// module id = 186
// module chunks = 0